/**
 * Must match Portal-Backend `config/storage.config.js` upload.maxFileSize
 * (override with env MAX_FILE_SIZE on the API).
 */
const MIB = 1024 * 1024;

export const MAX_CASE_DOCUMENT_UPLOAD_BYTES = 15 * MIB;

/** Human-readable cap; kept in sync with {@link MAX_CASE_DOCUMENT_UPLOAD_BYTES}. */
export const MAX_CASE_DOCUMENT_UPLOAD_LABEL = `${MAX_CASE_DOCUMENT_UPLOAD_BYTES / MIB}MB`;
